import { render, staticRenderFns } from "./NumberInfo.vue?vue&type=template&id=744a8dbc"
import script from "./NumberInfo.vue?vue&type=script&lang=js"
export * from "./NumberInfo.vue?vue&type=script&lang=js"
import style0 from "./NumberInfo.vue?vue&type=style&index=0&id=744a8dbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports